import * as React from 'react';
import { SVGProps } from 'react';
const GoogleLogo = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={22}
		height={22}
		viewBox="0 0 22 22"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_180_1906)">
			<path
				d="M21.57 11.005C21.5682 10.3344 21.508 9.66517 21.39 9.00499H11.22V13.085H17.34C16.9588 14.4654 16.1284 15.6794 14.98 16.535L18.1599 19.065C19.2496 18.0263 20.1145 16.7751 20.7011 15.3887C21.2876 14.0023 21.5833 12.5103 21.57 11.005V11.005Z"
				fill="#3284FF"
			/>
			<path
				d="M11.34 4.585C12.8104 4.58741 14.2306 5.11998 15.34 6.085L18.2799 3.085C16.3899 1.22484 13.8418 0.18618 11.19 0.194987C9.18843 0.213477 7.23076 0.783232 5.53189 1.84172C3.83303 2.9002 2.45869 4.40646 1.55997 6.19499L5.16995 8.94499C5.62971 7.67489 6.46759 6.57613 7.57071 5.79661C8.67383 5.01709 9.98928 4.59426 11.34 4.585Z"
				fill="#FF3424"
			/>
			<path
				d="M1.6599 15.945L5.12999 13.175C4.67929 11.7941 4.70033 10.3026 5.18993 8.93498L1.58995 6.18498C0.818051 7.69785 0.420576 9.37393 0.431017 11.0723C0.441458 12.7707 0.859568 14.4417 1.65001 15.945H1.6599Z"
				fill="#FFBB00"
			/>
			<path
				d="M5.13004 13.175L1.65994 15.945C2.57316 17.6946 3.94547 19.1625 5.62967 20.1914C7.31387 21.2202 9.24646 21.7712 11.22 21.785C13.8225 21.8051 16.3315 20.8158 18.22 19.025L15.05 16.495C13.9963 17.2899 12.7099 17.7152 11.39 17.705C10.0029 17.7035 8.65148 17.2651 7.52774 16.4519C6.404 15.6387 5.56508 14.4921 5.13004 13.175V13.175Z"
				fill="#26B14C"
			/>
		</g>
		<defs>
			<clipPath id="clip0_180_1906">
				<rect
					width={21.14}
					height={21.57}
					fill="white"
					transform="translate(0.429993 0.214996)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export default GoogleLogo;
